exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".regular__PhWm {\n  width: 100%; }\n\n.wide__3boC {\n  width: calc(100% + 40px); }\n\n.openRight__1SX4 {\n  right: 0; }\n\n.wide__3boC.openRight__1SX4 {\n  width: 100%; }\n  @media all and (max-height: 1000px) {\n    .wide__3boC.openRight__1SX4 {\n      width: calc(100% + 40px); } }\n\n.openLeft__1pLG {\n  margin-right: 8px; }\n", "", {"version":3,"sources":["/app/src/components/dropdown/src/components/dropdown/option-button.scss"],"names":[],"mappings":"AAAA;EACE,YAAY,EACb;;AAED;EACE,yBAAW,EACZ;;AAED;EACE,SAAS,EACV;;AAED;EACE,YAAY,EAIb;EAHC;IAFF;MAGI,yBAAW,EAEd,EAAA;;AAED;EACE,kBAAkB,EACnB","file":"option-button.scss","sourcesContent":[".regular {\n  width: 100%;\n}\n\n.wide {\n  width: calc(100% + 40px);\n}\n\n.openRight {\n  right: 0;\n}\n\n.wide.openRight {\n  width: 100%;\n  @media all and (max-height: 1000px){\n    width: calc(100% + 40px);\n  }\n}\n\n.openLeft {\n  margin-right: 8px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"regular": "regular__PhWm",
	"wide": "wide__3boC",
	"openRight": "openRight__1SX4",
	"openLeft": "openLeft__1pLG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/dropdown/option-button.scss
// module id = 875
// module chunks = 0